<ion-button
	[ngClass]="{
		'error-class':
			form.get(dynamicFormControl.key).invalid &&
			(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
		signed: dynamicFormControl.value !== undefined && dynamicFormControl.value === ''
	}"
	[disabled]="dynamicFormControl.disabled"
	(click)="accessPreviewReport()"
>
	<ion-icon
		*ngIf="dynamicFormControl.value !== undefined && dynamicFormControl.value === ''"
		class="icon-Save"
	></ion-icon>
	<ion-text>{{
		(dynamicFormControl.value !== undefined && dynamicFormControl.value === ''
			? 'signature.isSigned'
			: 'entry.report.title'
		) | translate
	}}</ion-text>
</ion-button>
